import { Injectable } from '@angular/core';
import { FrameContext, BindingData, BindingList, BindingObject } from '@farris/devkit';
import { EntityTraversingService } from './entity-traversing.service';

interface SplitedPath {
  listPath: string[];
  propPath: string[];
}

/**
 * å®ä½èåæå¡
 */
@Injectable()
class EntityAggregationService {

  private get bindingData(): BindingData {
    return this.frameContext.bindingData;
  }

  private traversingService: EntityTraversingService;

  constructor(private frameContext: FrameContext) {
    this.traversingService   = this.frameContext.injector.get<EntityTraversingService>(EntityTraversingService);
  }

  /**
   * è·åpathå¯¹åºåè¡¨è®°å½çæ¡æ°
   */
  public count(path: string[]): number {
    const splitedPath = this.splitPath(path);
    const entityListData = this.traversingService.getEntityListData(splitedPath.listPath);
    return entityListData.length;
  }

  /**
   * è·åpathå¯¹åºå­æ®µçå
   */
  public sum(path: string[]) {
    const splitedPath = this.splitPath(path);
    const entityListData = this.traversingService.getEntityListData(splitedPath.listPath);

    const total = entityListData.reduce((accTotal: number, entityData: any) => {
      let propValue = parseFloat(this.getPropValue(entityData, splitedPath.propPath));
      propValue = isNaN(propValue) ? 0 : propValue;
      accTotal += propValue;
      return accTotal;
    }, 0);
    return total;
  }

  /**
   * è·åpathå¯¹åºå­æ®µçå¹³åå¼
   */
  public avg(path: string[]) {
    const count = this.count(path);
    const total = this.sum(path);
    return count !== 0 ? total / count : 0;
  }

  /**
   * è·åpathå¯¹åºå­æ®µçæå¤§å¼
   */
  public max(path: string[]): number {
    const splitedPath = this.splitPath(path);
    const entityListData = this.traversingService.getEntityListData(splitedPath.listPath);

    const max =  entityListData.reduce((accMax: number, entityData: any) => {
      const propValue = parseFloat(this.getPropValue(entityData, splitedPath.propPath));
      if (isNaN(propValue) === false && ( !accMax || propValue > accMax)) {
        accMax = propValue;
      }
      return accMax;
    }, null);
    return max ? max : 0;
  }

  /**
   * è·åpathå¯¹åºå­æ®µçæå°å¼
   */
  public min(path: string[]): number {
    const splitedPath = this.splitPath(path);
    const entityListData = this.traversingService.getEntityListData(splitedPath.listPath);

    const min = entityListData.reduce((accMin: number, entityData: any) => {
      const propValue = parseFloat(this.getPropValue(entityData, splitedPath.propPath));
      if (isNaN(propValue) === false && ( !accMin || propValue < accMin)) {
        accMin = propValue;
      }
      return accMin;
    }, null);
    return min ? min : 0;
  }

  /**
   * è·åå±æ§å¼
   */
  private getPropValue(entityData: any, path: string[]) {
    let currentData = entityData;
    path.forEach((pathItem: string) => {

      // æåéåºçé½éç½®ä¸ºnullï¼ä¸»è¦éå¯¹å³èå¯¹è±¡æªèµå¼åºæ¯
      if (!currentData) {
        currentData = null;
        return;
      }
      currentData = currentData[pathItem];
    });

    return currentData;
  }

  /**
   * åéè·¯å¾ï¼åéç¬¦åè¡¨è·¯å¾åå±æ§è·¯å¾
   * @return å½¢å¦ {parentListPath: [], propertyPath: []}
   */
  private splitPath(path: string[]): SplitedPath {
    const listPath = path.concat([]);
    const propPath = [];
    let currentNode = this.bindingData.getValue(listPath);
    while (currentNode instanceof BindingList !== true) {
      const propPathItem = listPath.pop();
      if (!propPathItem) {
        return;
      }
      propPath.unshift(propPathItem);
      currentNode = this.bindingData.getValue(listPath);
    }

    return {
      listPath: listPath,
      propPath: propPath
    };
  }

}

export { EntityAggregationService };
